import React from 'react'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
// import NewspaperIcon from '@mui/icons-material/Newspaper';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
// import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import { convertDate, timeSince } from '../../../helpers/time';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { getRandomStr } from '../../../helpers';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    // color: 'rgba(0, 0, 0, 0.87)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  height: '100%',
  color: theme.palette.text.secondary,
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : 0,
  '& .Item-Head': {
    background: '#fbfbfc',
    borderBottom: '1px solid #eae9ee',
    marginBottom: 0,
    padding: theme.spacing(1, 2),
    borderRadius: '4px 4px 0 0',
    '& a': {
      textDecoration: 'none',
    },
    '& .option-title': {
      fontWeight: 600,
      color: '#13113c',
      fontSize: '.9rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(1),
  }
}));

const RecentFundNews = ({ news, title, columns, headBGColor, description }) => {
  return (
    <>
      {news &&
        <Item component="div" className="col-md-12" sx={{ mt: 1.2 }}>
          <Box component="div" className="row sum-r recent-news">
            <Box component="div" className="s-card">
              <Box
                className="Item-Head"
                sx={{ mb: 0.5, px: 0.5, background: headBGColor ?? '' }}
              >
                <Typography className="option-title" component="h4" sx={{ textAlign: 'left', mb: .3 }} >{(title || `Recent News`)}</Typography>
                {description && <Typography variant="body2" component="div" sx={{ fontSize: '.75rem !important', textAlign: 'left', mb: 1.5, }} >{description}</Typography>}
              </Box>
              <Box component="div" sx={{ display: 'flex', width: '100%', flexDirection: { md: columns === 1 ? 'column' : 'row', xs: 'column' } }}>
                <Box component="div" className="news-widget" sx={{ borderRight: columns === 1 ? '' : '1px solid #eae9ee', width: { md: columns === 1 ? '100%' : '50%', xs: '100%' } }}>
                  {news && news.slice(0, 8).map((d) => {
                    let n = (d.title).lastIndexOf('-');
                    let medianame = (d.title).substring(n + 1);
                    return (
                      <LightTooltip key={getRandomStr(3)} followCursor title={`${d.source}, ${convertDate(d.pubDate, "dd MMM yyyy")}, ${convertDate(d.pubDate, "hh:mm aaaaa'm'")}`} disableInteractive placement="top-end">
                        <Stack direction="row" key={d.link} sx={{ alignItems: 'center', width: '100%', borderBottom: '1px solid #eae9ee', '&:nth-child(even)': { background: '#f7f8fa' } }}>
                          <Box component="div" sx={{ px: 1, py: .5, '& .date-time': { display: 'none' }, '&:hover': { '& .date-time': { display: 'block' }, '& .day-ago': { display: 'none' } }, mt: 0.3, width: '18%' }}>
                            <Typography component="p" sx={{ fontSize: '.7rem', textAlign: 'left', mt: 0, '& .MuiChip-root:hover': { bgcolor: 'transparent' } }} className="mb-0">
                              <Chip label={d.source} sx={{ '& .MuiChip-label': { px: 0 }, bgcolor: 'transparent', p: 0, m: 0, fontSize: '.875rem', borderRadius: '5px', height: '1.5rem', color: 'text.description' }} />
                            </Typography>
                          </Box>
                          <Box component="div" sx={{ width: '82%', px: 1, py: .5 }}>
                            <Typography component="p" sx={{ fontSize: '.875rem', textAlign: 'left', '& a': { color: 'text.link', textDecoration: 'none', fontSize: '.875rem' }, '& a:hover': { textDecoration: 'underline' } }} className="news-title" >
                              <a
                                href={d.link}
                                target='_blank'
                                rel="noreferrer noopener"
                                dangerouslySetInnerHTML={{ __html: (d.title).replace(` -${medianame}`, '.') }}
                              />
                              <Typography component="body1" className="day-ago" sx={{ fontSize: '.7rem', textAlign: 'left', mt: 0, ml: .7, '& .MuiChip-root:hover': { bgcolor: 'transparent' }, color: '#6E6E8C', whiteSpace: 'nowrap' }}>
                                {timeSince(new Date(d.pubDate))} ago
                              </Typography>
                            </Typography>
                          </Box>
                        </Stack>
                      </LightTooltip>)
                  }
                  )}
                </Box>
                <Box component="div" className="news-widget" sx={{ borderLeft: columns === 1 ? '' : '1px solid #eae9ee', width: { md: columns === 1 ? '100%' : '50%', xs: '100%' } }}>
                  {news && news.slice(8, news.length).map((d) => {
                    let n = (d.title).lastIndexOf('-');
                    let medianame = (d.title).substring(n + 1);
                    return (
                      <LightTooltip key={getRandomStr(3)} followCursor title={`${d.source}, ${convertDate(d.pubDate, "dd MMM yyyy")}, ${convertDate(d.pubDate, "hh:mm aaaaa'm'")}`} disableInteractive placement="top-end">
                        <Stack direction="row" key={d.link} sx={{ alignItems: 'center', width: '100%', borderBottom: '1px solid #eae9ee', '&:nth-child(even)': { background: '#f7f8fa' } }}>
                          <Box component="div" sx={{ px: 1, py: .5, '& .date-time': { display: 'none' }, '&:hover': { '& .date-time': { display: 'block' }, '& .day-ago': { display: 'none' } }, mt: 0.3, width: '18%' }}>
                            <Typography component="p" sx={{ fontSize: '.7rem', textAlign: 'left', mt: 0, '& .MuiChip-root:hover': { bgcolor: 'transparent' } }} className="mb-0">
                              <Chip label={d.source} sx={{ '& .MuiChip-label': { px: 0 }, bgcolor: 'transparent', p: 0, m: 0, fontSize: '.875rem', borderRadius: '5px', height: '1.5rem', color: 'text.description' }} />
                            </Typography>
                          </Box>
                          <Box component="div" sx={{ width: '82%', px: 1, py: .5 }}>
                            <Typography component="p" sx={{ fontSize: '.875rem', textAlign: 'left', '& a': { color: 'text.link', textDecoration: 'none', fontSize: '.875rem' }, '& a:hover': { textDecoration: 'underline' } }} className="news-title" >
                              <a
                                href={d.link}
                                target='_blank'
                                rel="noreferrer noopener"
                                dangerouslySetInnerHTML={{ __html: (d.title).replace(` -${medianame}`, '.') }}
                              />
                              <Typography component="body1" className="day-ago" sx={{ fontSize: '.7rem', textAlign: 'left', mt: 0, ml: .7, '& .MuiChip-root:hover': { bgcolor: 'transparent' }, color: '#6E6E8C !important', whiteSpace: 'nowrap' }}>
                                {timeSince(new Date(d.pubDate))} ago
                              </Typography>
                            </Typography>
                          </Box>
                        </Stack>
                      </LightTooltip>)
                  }
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Item>}
    </>
  )
}

export default (RecentFundNews)
